import styled from 'styled-components';

export const Form = styled.form({
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '100%',
    gap: '16px'
});
